import { Navigate } from "react-router-dom";
import { getIsAutheticate } from "./common";
import { getUserData } from "./common";

export const PrivateRoutes = ({ children }: any) => {
    const isAuthenticate = getIsAutheticate();
    const userData = getUserData();

    try {
        if (!isAuthenticate) {
            document.title = "Complaint Management System";
            return <Navigate to='/' />
        } else {
            document.title =
                "Complaint Management System | User Name : " +
                userData.FirstName +
                " | Last Login: " +
                userData.LastLogin;
            return <>{children}</>
        }
    } catch (error) {
        document.title = "Complaint Management System";
        return <Navigate to='/' />
    }
};